// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class DocumentResource extends Resource {
    basePath: string = 'documents/document/';

    objectPath: string = 'documents/document/{ident}/';

    searchPath: string = 'documents/search-documents/';

    _getSearchPath = () => this.searchPath;

    search(query: Object): Promise<Object> {
        return this.client._request(this._getSearchPath(), 'GET', query).then((response) => response.data);
    }

    // Override list method to use searchPath
    list(query: Object): Promise<Object> {
        return this.client._request(this._getSearchPath(), 'GET', query).then((response) => response.data);
    }

    // This does not go to the search viewset, but to the object viewset
    filter(query: Object): Promise<Object> {
        return this.client._request(this._getBasePath(), 'GET', query).then((response) => response.data);
    }

    move(data: Object): Promise<Object> {
        return this.client._request(
            `${this._getBasePath()}move/`,
            'POST', data,
        );
    }

    changeStatus(data: Object): Promise<Object> {
        return this.client._request(
            `${this._getBasePath()}change_status/`,
            'POST', data,
        );
    }
}
